import { render, staticRenderFns } from "./monaco-editor.vue?vue&type=template&id=1201a62b&lang=pug&"
import script from "./monaco-editor.vue?vue&type=script&lang=js&"
export * from "./monaco-editor.vue?vue&type=script&lang=js&"
import style0 from "./monaco-editor.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "monaco-editor.vue"
export default component.exports